const module = { name: 'fd-location', exports: {} }; const exports = module.exports;



import { fd_location_alertBox as alertBox } from 'require-global';



import { default as _locationFormCreation } from 'swug-fdRequire-call:fd-location/form/creation';



import { default as _locationFormEvents } from 'swug-fdRequire-call:fd-location/form/events';



import { fd_location_utils as fd_location_utils_getLocation__getLocation_updateLocation__updateLocation_setUserLocationCookie__setUserLocationCookie } from 'require-global';

const { getLocation: _getLocation, updateLocation: _updateLocation, setUserLocationCookie: _setUserLocationCookie } = fd_location_utils_getLocation__getLocation_updateLocation__updateLocation_setUserLocationCookie__setUserLocationCookie;
function init() {
    alertBox.init();
}
document.addEventListener('DOMContentLoaded', init);
module.exports = {
    getLocation: _getLocation,
    updateLocation: _updateLocation,
    locationFormCreation: _locationFormCreation,
    locationFormEvents: _locationFormEvents,
    setUserLocationCookie: _setUserLocationCookie
};
export default module.exports;